import { Stone } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const StoneIcon = createLucideIcon(Stone);
